import { createFileRoute, redirect } from "@tanstack/react-router";
import { lazy } from "react";
const SEODynamicPage = lazy(() => import("@/pages/SEODynamicPage"));

// Legacy single-segment URLs that permanently redirect (moved here because
// TanStack's codegen cannot distinguish "/first500" from "/first-500").
const LEGACY_SLUG_REDIRECTS: Record<string, string> = {
  first500: "/first-500",
};

export const Route = createFileRoute("/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUG_REDIRECTS[params.slug];
    if (target) {
      throw redirect({ to: target, replace: true });
    }
  },
  component: SEODynamicPage,
});
